<template>
  <v-menu v-model="menu_ativo" :close-on-content-click="false" transition="scale-transition">
    <template v-slot:activator="{}">
      <SysBtn @click="menu_ativo = !menu_ativo">
        <v-icon size="18">mdi-filter</v-icon>
        <span class="ml-1">Filtros</span>
      </SysBtn>
    </template>

    <v-card class="pb-2 w-550 border-gray-500 overflow-y-auto" elevation="10" style="max-height: 95vh">
      <v-card-title class="pl-4 pr-1 py-2">
        <div>
          <p class="ma-0 font-18 text-gray-900">Filtragem de produtos</p>
          <p class="ma-0 font-12 font-weight-regular mt-n3 text-gray-200">Selecione o que você deseja considerar na análise</p>
        </div>

        <v-spacer />

        <v-btn icon @click="menu_ativo = !menu_ativo">
          <v-icon size="22">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pl-2 pr-1">
        <div class="px-1">
          <TiposProdutoAutocomplete
            v-model="filtros.tipos_produtos"
          />

          <div class="mt-3">
            <SysCompradorAutocomplete
              v-model="filtros.compradores"
              label="Compradores"
              :qtde_visivel_selecionados="1"
              :ids-segmento="filtros.segmentos"
              outlined
              multiple
              hide-details
              clearable
            >
              <template #selection="{item}">
                <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros.compradores" :item="item" item_value="nome" />
              </template>
            </SysCompradorAutocomplete>
          </div>

          <div class="mt-3">
            <SysSegmentoAutocomplete
              v-model="filtros.segmentos"
              label="Segmentos"
              :qtde-visivel-selecionados="1"
              outlined
              multiple
              hide-details
              clearable
            >
              <template #selection="{item}">
                <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros.segmentos" :item="item" />
              </template>
            </SysSegmentoAutocomplete>
          </div>

          <div class="mt-3">
            <SysLinhasAutocomplete
              v-model="filtros.linhas"
              label="Linhas"
              :qtde_visivel_selecionados="1"
              outlined
              multiple
              hide-details
              clearable
            >
              <template #selection="{item}">
                <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros.linhas" :item="item" />
              </template>
            </SysLinhasAutocomplete>
          </div>

          <div class="mt-3">
            <SysFornecedorAutocomplete
              v-model="filtros.fornecedores"
              label="Fornecedores"
              :qtde-visivel-selecionados="1"
              :ids-segmento="filtros.segmentos"
              :ids-comprador="filtros.compradores"
              outlined
              multiple
              hide-details
              clearable
            >
              <template #selection="{item}">
                <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros.fornecedores" :item="item" />
              </template>
            </SysFornecedorAutocomplete>
          </div>

          <div v-if="filtro_produtos_mix_filial" class="mt-3">
            <SysAutocomplete
              v-model="filtros.produtos_mix_filial"
              label_props="Produtos Mix Filial"
              :items_props="selects.items_props_produtos_mix_filial"
            />
          </div>

          <div class="mt-3">
            <SysMarcaAutocomplete
              v-model="filtros.marcas"
              label="Marcas"
              :qtde-visivel-selecionados="1"
              :ids-segmento="filtros.segmentos"
              :ids-comprador="filtros.compradores"
              outlined
              multiple
              hide-details
              clearable
            >
              <template #selection="{item}">
                <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros.marcas" :item="item" />
              </template>
            </SysMarcaAutocomplete>
          </div>
        </div>
      </v-card-text>

      <div class="d-flex px-2">
        <v-spacer />

        <v-btn small color="#042333" dark @click="aplicarFiltros">
          filtrar
        </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import TextoOutrosFiltrosSelecionadosAutocomplete from "@/components/Diagnostico/utils/TextoOutrosFiltrosSelecionadosAutocomplete.vue";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";
import SysLinhasAutocomplete from "@/components/utils/crud/SysLinhasAutocomplete.vue";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import TiposProdutoAutocomplete from "@/components/indicadores/SysTiposProdutoAutocomplete.vue";
import SysAutocomplete from "@/components/utils/crud/SysAutocomplete.vue";
import SysMarcaAutocomplete from "@/components/utils/crud/SysMarcaAutocomplete.vue";

export default {
  name: "Filtros",
  components: {
    SysAutocomplete,
    TiposProdutoAutocomplete,
    SysCompradorAutocomplete,
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    SysLinhasAutocomplete,
    SysMarcaAutocomplete,
    TextoOutrosFiltrosSelecionadosAutocomplete
  },
  data: () => ({
    menu_ativo: false,
    filtros: {
      tipos_produtos: ['PRODUTOS_NAO_COMBINADOS', 'PRODUTOS_COMBINADOS'],
      compradores: [],
      segmentos: [],
      linhas: [],
      fornecedores: [],
      marcas: [],
      produtos_mix_filial: [2]
    },
    selects: {
      items_props_produtos_mix_filial: [
        { id: 1, descricao: '1. Produtos Fora do Mix' },
        { id: 2, descricao: '2. Produtos no Mix' },
      ]
    },
    filtro_produtos_mix_filial: localStorage.getItem('mix_produtos_filial_ativar_limitacao_visualizacao') === 'S'
  }),
  props: {
    filtro_linha: Array
  },
  created() {
    this.filtros.linhas = this.filtro_linha;
  },
  methods: {
    aplicarFiltros() {
      this.menu_ativo = false;
      this.$emit("update:filtros", {filtros: this.filtros})
    }
  }
}
</script>

<style scoped>
</style>
